import React, { useState, useContext, useEffect } from 'react'
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { useTranslation } from 'react-i18next'
import { subscribe } from '../utils/pubsub'
import Spinner from '../ui-elements/Spinner'

type Props = {

}


function SingleSignOn({
}: Props) {

    const {
        setShowModal,
        sendMessageToWebsocket,
        connectionState
    } = useContext(GlobalContext)

    const { t } = useTranslation()

    const [client_id, setClientId] = useState<string>('')
    const redirect_url_raw = CloudformationOutputs['EntraRedirectLambdaUrl']
    const redirect_url = encodeURIComponent(redirect_url_raw)
    const currentUrlOrigin = window.location.origin
    const forceAccountSelect = localStorage.getItem('forceAccountSelect') === 'true'
    const entraUrl = `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_url}&scope=openid%20profile%20email&state=${currentUrlOrigin}${forceAccountSelect ? '&prompt=select_account' : ''}`


    useEffect(() => {
        if (!client_id && connectionState === 'connected-awaiting-login') {
            fetchclientId()
        } 
    }, [client_id, connectionState])


    const fetchclientId = async () => {
        //console.log('Fetching client ID for SSO')
        const payload = {
            "action": "sso"
        }
        const unsubscribe = subscribe("returnEntraId", data => {
            //console.log('Received client ID for SSO:', data)
            if (data && data.entraClientId) {
                setClientId(data.entraClientId)
            }
            unsubscribe()
        })
        sendMessageToWebsocket(JSON.stringify(payload))

    }

    if (!client_id) {
        return null
        // return <Spinner></Spinner>
    }

    const isPhoneMode = !!(window as any).isPhoneMode

    const handleMicrosoftLogin = (e: React.MouseEvent) => {
        if (isPhoneMode) {
            e.preventDefault()
            ;(window.parent as any).requestPhoneModeAfterLogin?.(entraUrl)
        }
    }

    return <div className={'animate-fadein w-full flex flex-col gap-2'}>

        <a href={entraUrl} onClick={handleMicrosoftLogin} className={`w-full px-3 py-3 bg-white flex flex-row gap-4 items-center justify-center cursor-pointer hover:opacity-80 text-gray-800 border-gray-400 rounded`}>
            <img src={`/logos/microsoft.svg`} alt='' className={`w-6 h-6`} />
            {t('Auth.SingleSignOn.logInWithMicrosoft')}
        </a>

    </div>
}
export default SingleSignOn